module.exports = __webpack_public_path__ + "img/logo.e2bf947f.png";